import React, { ReactNode } from 'react';
import { SettingsSidebar } from './SettingsSidebar';

interface Props {
  children: ReactNode;
}

export const SettingsLayout = ({ children }: Props) => {
  return (
    <div className="tw-flex tw-h-full tw-min-h-0">
      <SettingsSidebar />
      <div className="tw-min-h-0 tw-min-w-0 tw-flex-1">{children}</div>
    </div>
  );
};
